import $ from 'jquery/dist/jquery.slim'


import { getLoadedBackground } from './utils'
import Transition from './transition'
import scrollTop from './scrollTop'


export default function (clicked) {

    let app     = $('#app'),
        origin  = window.location.pathname,
        path    = origin.substring(origin.lastIndexOf('/'));

    getPage(path)

    function getPage(clicked) {

        let page = clicked ? clicked : path,
            url  = origin;

        switch(page) {
            case '/':
                url = 'landing.html';
                break;

            case '/ortung':
                url = 'ortung.html'
                break;

            case '/anschrift':
                url = 'anschrift.html'
                break;

            case '/kaufverhalten':
                url = 'kaufverhalten.html'
                break;

            case '/browser-verlauf':
                url = 'browser-verlauf.html'
                break;

            default:
                url = 'landing.html';
                break;

        }

        // if( page === '/' ) {
        //     url = '/landing.html';
        // } else {
        //     url = page + '/html';
        // }


        let title = page.replace('/', '').capitalize();

        if( title !== '' ) { title += ' | ' }

        document.title = title + 'Datensammlung';

        loadData(page, url)

    }


    function loadData(page, url) {

        $('body').removeClass().addClass(page.replace('/', ''));

        fetch(url)
            .then(res => res.text())
            .then(html => {
                app.html(html);


                // add current link
                if( page !== '/' ) {
                    $('nav a[href="' + page + '"]').addClass('is-current');
                    $('#nav-main').addClass('fade-in');
                }
                else {
                    $('#nav-main').removeClass('fade-in');
                }


            })
            .then(() => {

                let src;

                page === '/' ? src = $('#content').css('background-image')
                             : src = $('#header, #content').css('background-image');

                //console.log(page);

                getLoadedBackground(src, () => {
                    $('#nav-main').removeClass('fade-color');
                    $('#header, #content').addClass('fade-in');
                    $('#footer').css({ 'display': 'block' });
                    $('.spinner').hide();
                })

            })


    }


    window.addEventListener('popstate', e => {

        let title   = e.state,
            url     = e.state ? '/' + e.state.toLowerCase() : '';

            console.log(url);

        $('nav a').removeClass('is-current');

        Transition()

        scrollTop(400, () => {

            $('#header, #content').removeClass('fade-in');
            //setTimeout(() => {
                $('.spinner').show()
            //}, 500)

        });

        document.getElementById('content').onCSSTransitionEnd(() => {

            if( title === null ) {
                loadData('/', window.location.pathname + '/landing.html')
                document.title = 'Datensammlung';
            }
            else getPage(url)
        });

    }) // end pop

}



// WEBPACK FOOTER //
// ./src/js/router.js